@if (model) {
  <div class="apply-one-style apply-one-grid">
    <div class="site-width bg-dark mr--4" [ngClass]="{ 'main-content-full-width': isNativeApp }">
      <div class="container-fluid pt-1">
        <div class="row no-gutters text-white align-items-stretch">
          <div class="col-9 col-md-8 border-right border-dark">
            <div class="forbidden-banner-title d-flex align-items-center mt-1 mb-1">
              <img
                class="forbidden-banner-logo ob1-logo mr-1"
                [src]="model.logo.imageSource"
                [alt]=""
                aria-hidden="true"
              />
              <h3 class="h3 m-0 p-0" aria-hidden="true">
                {{ model.title }}
              </h3>
            </div>
            <p class="pb-0 mb-2 pr-1">
              <strong>{{ model.subtitle }}</strong>
            </p>

            <p class="small d-none d-md-block" [id]="'scanqrcode'" [attr.aria-label]="detailAriaLabel">
              {{ model.detail }}
            </p>
            <a [href]="qrCodeUrl" [attr.aria-labelledby]="'scanqrcode'">
              <span class="sr-only">{{ qrCodeUrl }}</span>
            </a>

            <div class="banner-buttons d-flex flex-column flex-md-row mb-1">
              @if (!isNativeApp) {
                <img
                  [alt]=""
                  class="mb-1 mr-1"
                  [attr.aria-hidden]="true"
                  [attr.data-e2e]="'e2e-protected-qrcode-image'"
                  [src]="qrCodeUrl | qrCode: 64 | async"
                />
              }
              @for (btn of model.buttons; track btn) {
                <a class="mb-1 mr-1" href="{{ btn.hrefLink }}" (click)="onBadgeClick(btn); (false)">
                  <img [src]="btn.imageSource" alt="" [attr.aria-hidden]="true" />
                </a>
              }
            </div>
          </div>
          <div class="col-3 col-md-4 align-self-end">
            @if (isNativeApp) {
              <img
                [alt]=""
                [attr.data-e2e]="'e2e-mobile-image'"
                aria-hidden="true"
                [src]="model.mobile.imageSource"
                class="mt--2"
                style="height: 350px"
              />
            } @else {
              <img
                [alt]=""
                [attr.data-e2e]="'e2e-mobile-image'"
                aria-hidden="true"
                [src]="model.mobile.imageSource"
                class="mt--3 ml-2"
                style="height: 330px"
              />
            }
          </div>
        </div>
      </div>
    </div>
  </div>
}
